import { MapPin, Navigation, Building2, Train, Briefcase, ShoppingCart, BookOpen, Stethoscope } from "lucide-react";

const LocationSection = () => {
  const landmarks = [
    { icon: Building2, text: "OMR (Old Mahabalipuram Road) proximity", color: "blue" },
    { icon: Train, text: "Near Kelambakkam railway station", color: "green" },
    { icon: Briefcase, text: "Close to IT parks and business districts", color: "purple" },
    { icon: ShoppingCart, text: "Shopping malls and retail centers nearby", color: "orange" },
    { icon: BookOpen, text: "Educational institutions in vicinity", color: "red" },
    { icon: Stethoscope, text: "Healthcare facilities accessible", color: "pink" },
  ];

  return (
    <section id="location" className="py-20 sm:py-28 bg-slate-50">
      <div className="section-container">
        <h2 className="section-title">Location & Connectivity</h2>
        <p className="section-subtitle">
          Strategically positioned in Kelambakkam, Tamil Nadu
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Map Placeholder with Better Design */}
          <div className="bg-gradient-to-br from-blue-100 via-blue-50 to-slate-50 rounded-2xl overflow-hidden shadow-xl border border-blue-200 h-96 flex items-center justify-center relative">
            <div className="absolute inset-0 bg-gradient-to-t from-blue-600/10 to-transparent"></div>
            <div className="text-center relative z-10">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full shadow-lg mb-4">
                <MapPin className="w-10 h-10 text-blue-600" />
              </div>
              <p className="text-blue-900 font-bold text-xl">
                Kelambakkam
              </p>
              <p className="text-blue-600 text-sm mt-2">
                Premium residential location
              </p>
              <p className="text-blue-500 text-xs mt-3 px-4">
                Strategically positioned on OMR with excellent connectivity
              </p>
            </div>
          </div>

          {/* Location Details with Better Organization */}
          <div>
            {/* Address Card */}
            <div className="bg-white border-l-4 border-l-blue-600 rounded-lg p-6 mb-8 shadow-md hover:shadow-lg transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-blue-100 rounded-lg flex-shrink-0">
                  <MapPin className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-bold text-lg text-foreground mb-1">
                    Address
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    Purva Swanlake, 1/367 A, Renugambal Nagar, OMR Road, Kelambakkam, Tamil Nadu 603103
                  </p>
                  <a href="https://maps.app.goo.gl/xu8WuqE42teJkirk8" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 text-sm font-semibold mt-3 inline-block transition-colors duration-300">
                    View on Google Maps →
                  </a>
                </div>
              </div>
            </div>

            {/* Landmarks Grid */}
            <div>
              <h3 className="font-bold text-lg text-foreground mb-4">
                Nearby Landmarks & Connectivity
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {landmarks.map((landmark, index) => {
                  const Icon = landmark.icon;
                  const colorClasses = {
                    blue: "bg-blue-50 border-blue-200 text-blue-600",
                    green: "bg-green-50 border-green-200 text-green-600",
                    purple: "bg-purple-50 border-purple-200 text-purple-600",
                    orange: "bg-orange-50 border-orange-200 text-orange-600",
                    red: "bg-red-50 border-red-200 text-red-600",
                    pink: "bg-pink-50 border-pink-200 text-pink-600",
                  };
                  return (
                    <div key={index} className={`${colorClasses[landmark.color as keyof typeof colorClasses]} border rounded-lg p-4 hover:shadow-md transition-all duration-300 transform hover:-translate-y-0.5`}>
                      <div className="flex items-start gap-3">
                        <Icon className="w-5 h-5 flex-shrink-0 mt-0.5" />
                        <span className="text-sm font-medium text-foreground">{landmark.text}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
